import Pages from 'Src/const/pages'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// router异常捕获
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

/* name 请配置为 Src/pagelets/promotion/promotion-state.js 中 key 的小写值 */

const routers = [
  {
    path: '/',
    redirect: '/ad'
  },
  {
    path: '/campaign',
    name: 'campaign',
    children: [],
    // component: () => import(/* webpackChunkName: "PromotionCampaign" */ 'Src/pagelets/promotion/campaign/campaign.vue')
    component: (resolve) => require.ensure(
      [],
      require => {
        resolve(require('Src/pagelets/promotion/campaign/campaign.vue'))
      },
      () => {},
      'PromotionCampaign'
    )
  },
  {
    path: '/ad',
    name: 'ad',
    children: [],
    // component: () => import(/* webpackChunkName: "PromotionAd" */ 'Src/pagelets/promotion/ad/ad.vue')
    component: (resolve) => require.ensure(
      [],
      require => {
        resolve(require('Src/pagelets/promotion/ad/ad.vue'))
      },
      () => {},
      'PromotionAd'
    )
  },
  {
    path: '/creative',
    name: 'creative',
    children: [],
    // component: () => import(/* webpackChunkName: "PromotionCreative" */ 'Src/pagelets/promotion/creative/creative.vue')
    component: (resolve) => require.ensure(
      [],
      require => {
        resolve(require('Src/pagelets/promotion/creative/creative.vue'))
      },
      () => {},
      'PromotionCreative'
    )
  },
  {
    path: '/keyword',
    name: 'keyword',
    children: [],
    // component: () => import(/* webpackChunkName: "PromotionKeyword" */ 'Src/pagelets/promotion/keyword/keyword.vue')
    component: (resolve) => require.ensure(
      [],
      require => {
        resolve(require('Src/pagelets/promotion/keyword/keyword.vue'))
      },
      () => {},
      'PromotionKeyword'
    )
  },
  {
    path: '*',
    name: 'not-found',
    children: [],
    // component: () => import(/* webpackChunkName: "PromotionAd" */ 'Src/pagelets/promotion/ad/ad.vue')
    component: (resolve) => require.ensure(
      [],
      require => {
        resolve(require('Src/pagelets/promotion/ad/ad.vue'))
      },
      () => {},
      'PromotionAd'
    )
  }
]

const RouterConfig = {
  mode: 'hash',
  base: `/pages/${Pages.promotion.filename}`,
  routes: routers
}

const VueRouterIns = new VueRouter(RouterConfig)
// 记录 tab 切换的次数，用于 ad.js 判断是否是首次进入 ad.js
Vue.SwitchCount = 0
VueRouterIns.beforeEach((to, from, next) => {
  Vue.SwitchCount += 1
  next()
})

export default VueRouterIns
